module.exports = __webpack_public_path__ + "static/ilustracePohreb1-965cdee4d4e93048c96d883aa202fb6b.svg";